import * as React from "react";
import { TextField } from "@mui/material";
import templateStyles from "../contact-main.module.css";
import styles from "./FormInputsContainer.module.css";
import DatePickerComponent from "../../../../common/v2/datepicker/DatePickerComponent";
import CTAButton from "../../../../common/v2/CTA-Button/cta-button";
import { FormElement } from "../types";

interface Props {
    formData: FormElement[];
    onChange: (name: string, value: any) => void;
    sendEmailData: (...args: any[]) => void;
}

const FormInputsContainer: React.FC<Props> = ({ formData, onChange, sendEmailData }) => {
    // separate the textarea field
    const textAreaField = formData.find((field) => field.type === "textarea");
    const otherFields = formData.filter((field) => field.type !== "textarea");

    return (
        <>
            {/* Grid for all inputs except textarea */}
            <div className={styles.form_grid}>
                {otherFields.map((field, index) => (
                    <div className={styles.input_container} key={index}>
                        {field.type === "date" ? (
                            <DatePickerComponent
                                label={field.name}
                                value={field.value ? new Date(field.value) : null}
                                onChange={(date) => onChange(field.name, date)}
                            />
                        ) : (
                            <TextField
                                label={field.name}
                                variant="outlined"
                                fullWidth
                                value={field.value}
                                onChange={(e) => onChange(field.name, e.target.value)}
                                margin="dense"
                                required
                                type={
                                    field.type === "email"
                                        ? "email"
                                        : field.type === "phone"
                                            ? "tel"
                                            : "text"
                                }
                                sx={{
                                    "& .MuiInputBase-root": {
                                        backgroundColor: "white",
                                    },
                                    "& .MuiFormLabel-asterisk": { color: "red" },
                                }}
                            />
                        )}

                        {field.error && (
                            <p className={templateStyles.error_message}>{field.error}</p>
                        )}
                    </div>
                ))}
            </div>

            {/* Full-width textarea under the grid */}
            {textAreaField && (
                <div className={styles.input_container}>
          <textarea
              className={styles.text_area}
              placeholder={textAreaField.name}
              value={textAreaField.value}
              onChange={(e) => onChange(textAreaField.name, e.target.value)}
              required
              style={{
                  fontWeight: "bold",
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  borderColor: textAreaField.error ? "red" : "#ccc",
                  fontFamily: "inherit",
                  fontSize: "1rem",
              }}
          />
                    {textAreaField.error && (
                        <p className={templateStyles.error_message}>{textAreaField.error}</p>
                    )}
                </div>
            )}

            {/* Button */}
            <div className={styles.button_container}>
                <CTAButton text={"Soumettre"} onClick={sendEmailData} />
            </div>
        </>
    );
};

export default FormInputsContainer;
